import { ManagerRole } from '../../../../hooks/auth/usePermissions';

export default {
  [ManagerRole.SuperAdmin]: 'Super administrador',
  [ManagerRole.Admin]: 'Administrador',
  [ManagerRole.SalesManager]: 'Gestor de vendas',
  [ManagerRole.SalesLeadership]: 'Liderança de vendas',
  [ManagerRole.ContentManager]: 'Gestor de conteúdo',
  [ManagerRole.OnboardingManager]: 'Gestor de integração',
  [ManagerRole.OccAgent]: 'Agente de call-center',
};
